var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1666",
    "data-name": "Caminho 1666",
    d: "M48,24A24,24,0,1,0,20.25,47.708V30.937H14.156V24H20.25V18.713c0-6.015,3.583-9.338,9.065-9.338a36.906,36.906,0,0,1,5.372.469V15.75H31.661c-2.981,0-3.911,1.85-3.911,3.748V24h6.656l-1.064,6.938H27.75V47.708A24.006,24.006,0,0,0,48,24Z",
    fill: "#1877f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1667",
    "data-name": "Caminho 1667",
    d: "M170.186,121.563l1.064-6.937h-6.656v-4.5c0-1.9.93-3.748,3.911-3.748h3.026v-5.906a36.908,36.908,0,0,0-5.372-.469c-5.482,0-9.065,3.322-9.065,9.338v5.287H151v6.938h6.094v16.771a24.261,24.261,0,0,0,7.5,0V121.563Z",
    transform: "translate(-136.844 -90.625)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3cc20b93a0640cb0d63d3a0dd3407f25.svg";
export { ForwardRef as ReactComponent };